export const routeNames = {
  Call: "",
  Whatsapp: "",
  "Login View": "/loginView",
  "Otp Verification View": "/otpVerificationView",
  "Home View": "/homeView",
  "Notification View": "/notificationView",
  "City Selection View": "/citySelectionView",
  "Search Test View": "/searchTestView",
  "Cart View": "/cartView",
  "Main Nav View": "/mainNavView",
  "Profile View": "/profileView",
  "Bookings View": "/bookingsView",
  "Reports View": "/reportsView",
  "Select Location View": "/selectLocationView",
  "Booking Details Screen View": "/bookingDetailsScreenView",
  "Order Details View": "/orderDetailsView",
  "Routine Health Checkups View": "/routineHealthCheckupsView",
  "Upload Prescription View": "/uploadPrescriptionView",
  "Prescription Uploaded View": "/prescriptionUploadedView",
  "Search Package View": "/searchPackageView",
  "Edit Profile View": "/editProfileView",
  "Family Members View": "/familyMembersView",
  "Address View": "/addressView",
  "Package Details View": "/packageDetailsView",
  "Test Details View": "/testDetailsView",
  "Order Placed View": "/orderPlacedView",
};
